module.exports = __webpack_public_path__ + "static/media/squarePanel1.1f3371f2.svg";